import { Users, Compass, HeartHandshake } from "lucide-react";
import { Reveal } from "./shared";

const items = [
  { icon: Users, label: "Adolescents in CCIs", id: "adolescents-in-ccis" },
  { icon: Compass, label: "Care leavers", id: "care-leavers" },
  { icon: HeartHandshake, label: "Caregivers and institutions", id: "caregivers-and-institutions" },
];

export const WhoWeServe = () => (
  <section className="pb-24 md:pb-32" data-testid="who-we-serve-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-7">
        {items.map((item, i) => (
          <Reveal key={item.id} delay={i * 0.1} testId={`serve-card-${item.id}`} className="h-full">
            <div className="card-soft flex items-center gap-5 p-7 md:p-8 h-full">
              <div className="shrink-0 w-12 h-12 rounded-2xl bg-[#00867A]/10 flex items-center justify-center">
                <item.icon className="w-5 h-5 text-[#00867A]" strokeWidth={1.75} />
              </div>
              <h3 className="font-heading text-lg font-medium text-[#1F2043] leading-snug">
                {item.label}
              </h3>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
